<!--headers-->
<app-headers></app-headers>
<!--headers end-->

<section id="top-slider" class="top-slider">
    <div id="top-slider-content">
        <div class="container">
            <div class="row" id="top-slider-content-inner">
                <div class="col .slider-left-side">
                    <div class="slider-left-side-inner">
                        <h1 class="text-uppercase text-black" >Create your 
                            <span>
                                <span id="slider-text-website">Website</span>
                                <span id="slider-text-portfolio">Portfolio</span>
                                <span id="slider-text-blog">Blog</span>
                            </span>&nbsp;
                        </h1>
                        <h1  class="text-black text-uppercase">in 5 minutes</h1>
                        <p class="left-side-p" style="font-size: 22px;">
                            Jijengee allows you to design and publish your website all within the website. Sign up now for a 10% discount
                        </p>
                        <div class="text-center">
                            <a href="#signup">
                                <button class="btn btn-primary text-center get-started-intro-btn" type="button" >Sign Up Free</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="templates-section">
    <div class="templates-section-header-section">
        <div>
            <h1 class="section-heading">Outstanding Designs To Choose From</h1>
        </div>
        <div>
            <p class="section-heading-p">We have hand selected a couple of templates to help you get you started.</p>
        </div>
    </div>
    <div class="templates-section-templates">
        <div class="single-template-div"><a href="assets/img/34fb68ddbfb787f64f73f7bd7df124c2.jpg" data-fancybox="data-fancybox"><img src="assets/img/34fb68ddbfb787f64f73f7bd7df124c2.jpg"></a></div>
        <div class="single-template-div"><a href="assets/img/802745fb8188c0b998162cdc89ff7634.jpg" data-fancybox="data-fancybox"></a></div>
        <div class="single-template-div"><a href="assets/img/8c6a89b28553d08301eb2892affc7b27.jpg" data-fancybox="data-fancybox"><img src="assets/img/8c6a89b28553d08301eb2892affc7b27.jpg"></a></div>
    </div>
</section>
<div id="features"></div>
<section id="responsive-design" class="responsive-design-section">
    <div class="section-inner">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 left-side-p">
            <div class="left-side responsive-design-left">
                <h1 class="section-heading responsive-design-header" >Mobile Friendly</h1>
                <div class="responsive-design-section-p section-p">
                    <p class="text-white">Get a website that looks amazing in all devices</p>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8 right-side border">
            <div class="border responsive-right-side-inner"><img class="img-fluid" src="assets/img/2b73c6c9ee40105b82a39a112c50f2da.jpg"></div>
        </div>
    </div>
</section>
<section id="search-optimised" class="search-optimised">
    <div class="">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 search-optimised-right">
            <div>
                <h1 class="section-heading responsive-design-header">Search Optimised</h1>
            </div>
            <div class="section-p">
                <p class="responsive-design-section-p section-p text-white">Let potential customers find you on google. Make sure you never miss a lead.</p>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8 search-optimised-left">
            <div class="row">
                <div class="search-optimised-left-div "><img class="img-fluid" src="assets/img/stephen-phillips-hostreviews-co-uk-shr_Xn8S8QU-unsplash.jpg"></div>
            </div>
        </div>
    </div>
</section>
<section id="support-section" class="responsive-design-section">
    <div class="section-inner">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 left-side">
            <div class="left-side responsive-design-left">
                <h1 class="section-heading responsive-design-header">24hr support</h1>
                <div class="responsive-design-section-p section-p">
                    <p class="text-white">You need some help getting something done, simply reach out.</p>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-8 col-xl-8 right-side ">
            <div class="responsive-right-side-inner"><img class="img-fluid" src="assets/img/petr-machacek-BeVGrXEktIk-unsplash.jpg"></div>
        </div>
    </div>
</section>
<section id="contact-us" class="contact-us">
    <div id="signup" class=" row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 contact-us-left">
            <h1 class="">Sign up for a 10% discount. Limited Offer!</h1>
            <!-- <h1>Or valid for a limited time.</h1> -->
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="get-in-touch">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="shadow" style="width: 100%;min-height: 630px;margin-top: 119px;background-color: rgba(255,255,255,0.79);">
                                <form style="padding-top: 30px;">
                                    <div class="form-group">
                                        <h1 class="text-center">Sign Up.</h1>
                                    </div>
                                    <div class="form-group">
                                        <label for="name">Name:</label>
                                        <input class="form-control form-control-lg" type="text" style="width: 50%;margin-left: 25%;" required="" placeholder="Name">
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Email:</label>
                                        <input id="email" class="form-control form-control-lg" type="email" style="width: 50%;margin-left: 25%;" placeholder="Email">
                                    </div>
                                    <div class="form-group">
                                        <label for="business-description">Description:</label>
                                        <textarea id="business-description" class="form-control form-control-lg" style="width: 50%;margin-left: 25%;min-height: 200px;" placeholder="Short description of website the you need."></textarea></div>
                                    <div class="form-group">
                                        <button class="btn btn-dark btn-lg" style="width: 50%;margin-left: 25%;" type="submit">Sign Up</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--footers-->
<app-footers></app-footers>
<!--footers end-->